export const apiVersionPrefix = "/api/v0";
export const userPrefix = `${apiVersionPrefix}/user`;
export const fetchUserInfoPath = `${userPrefix}/getInfo`;
export const authPrefix = `${apiVersionPrefix}/auth`;
export const startSessionPath = `${authPrefix}/startSession`;

export const analyticsApiPrefix = `${apiVersionPrefix}/tracking`;
export const rewardsApiPrefix = `${apiVersionPrefix}/rewards`;

export const experimentsApiPrefix = `${apiVersionPrefix}/experiments`;
export const takeoversApiPrefix = `${apiVersionPrefix}/takeovers`;

export const eventSendPath = `${apiVersionPrefix}/event/send`;
export const fetchCarrotBalancePath = `${apiVersionPrefix}/balance/available`;
export const requestBalancePermissionPath = `${apiVersionPrefix}/balance/permission/request`;
